<div class="dialog">
  <div align="center">
    <div class="mat-headline" style="padding-bottom: 10px">{{ title }}</div>
    <mat-progress-spinner color="primary" mode="indeterminate" style="padding: 10px"></mat-progress-spinner>
    <div>Dit kan even duren...</div>
    <div>Gelieve dit tabblad niet te sluiten.</div>
  </div>
</div>
